export default {"src":"/_next/static/media/mediaLogo2.eda3ad07.svg","height":40,"width":234,"blurWidth":0,"blurHeight":0};